import { BaseService } from '../base';

interface TermsData {
  id: string;
  title: string;
  version: string;
  content: string;
  effectiveDate: string;
  isActive: boolean;
}

export class TermsService extends BaseService {
  private customBaseUrl = import.meta.env.VITE_API_URL;

  constructor() {
    super();
  }

  async getTerms(): Promise<{
    success: boolean;
    data?: TermsData;
    error?: string;
  }> {
    try {
      const response = await this.get(
        '/portal/v1/identity/terms-of-use',
        {},
        this.customBaseUrl
      );
      return await this.handleJsonResponse<TermsData>(response);
    } catch (error) {
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Erro de conexão',
      };
    }
  }

  async acceptTerms(
    termsVersion: string
  ): Promise<{ success: boolean; message?: string; error?: string }> {
    const acceptedAt = new Date().toISOString();
    try {
      const response = await this.post(
        '/portal/v1/identity/terms-of-use/accept',
        {
          termsVersion,
          acceptedAt,
        },
        {},
        this.customBaseUrl
      );
      return await this.handleJsonResponse(response);
    } catch (error) {
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Erro de conexão',
      };
    }
  }
}

export const termsService = new TermsService();
